import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { getDeviceInfo } from "store/actions";
import { withRouter } from "react-router-dom";
import { Card, CardHeader, Col, Input, Row } from "reactstrap";
import DeviceInfoTable from "containers/device-info/DeviceInfoTable";

export class DeviceInfoTab extends Component {
  constructor(props) {
    super(props);

    this.state = {
      userId: null,
      currentPage: 1,
      pageSize: 10,
    };
  }

  componentDidMount = () => {
    const { userId } = this.props;
    this.setState({
      userId,
    });
  };

  handleOnSearch = e => {
    const { userId } = this.state;
    const { value } = e.target;
    this.setState({
      term: value ?? "",
    });
    this.props.getDeviceInfo({ term: value ?? "", userId });
  };

  handleOnPageChange = page => {
    const { pageSize, userId } = this.state;
    this.props.getDeviceInfo({
      page,
      pageSize,
      userId,
    });
    this.setState({
      currentPage: page,
    });
  };

  handleOnPageSizeChange = pageSize => {
    const { userId } = this.state;
    this.props.getDeviceInfo({
      page: 1,
      pageSize,
      userId,
    });

    this.setState({
      pageSize,
    });
  };

  handleStatusFilter = ids => {
    const { userId } = this.state;
    this.props.getDeviceInfo({ userId, ids });
  };

  handleSearch = () => {
    const { term, startDate, endDate, userId } = this.state;
    this.props.getDeviceInfo({
      term: term ?? "",
      startDate: startDate
        ? moment(startDate).format("YYYY-MM-DDTHH:mm:ss.SSS")
        : "",
      endDate: endDate ? moment(endDate).format("YYYY-MM-DDTHH:mm:ss.SSS") : "",
      userId,
    });
  };

  handleOnViewDetail = id => {
    const { userId } = this.state;
    const { history } = this.props;
    history.push(`/device-info/${id}/${userId}`);
  };

  render() {
    const { deviceInfo } = this.props;
    const { pageSize, currentPage } = this.state;
    const { items, itemCount, pageCount, loading } = deviceInfo;
    return (
      <>
        <Card className="mb-2 rounded-2">
          <CardHeader className="bg-transparent border pb-1 pt-3">
            <Row className="g-1">
              <Col md={2}>
                <div className="search-box me-2 mb-2 d-inline-block">
                  <div className="position-relative">
                    <Input
                      type="text"
                      placeholder="Quick Search ..."
                      onChange={this.handleOnSearch}
                    ></Input>
                    <i className="fas fa-search search-icon" />
                  </div>
                </div>
              </Col>
              <Col md={6}></Col>
              <Col md={4}>
                {/* <div className="text-sm-end">
                  <Button
                    type="button"
                    color="primary"
                    onClick={this.handleOnAddNew}
                  >
                    <i className="fas fa-plus" /> Add New
                  </Button>
                </div> */}
              </Col>
            </Row>
          </CardHeader>
        </Card>
        {items && (
          <>
            <DeviceInfoTable
              items={items}
              itemCount={itemCount}
              currentPage={currentPage}
              totalPage={pageCount}
              loading={loading}
              defaultPageSize={pageSize}
              onChangePage={this.handleOnPageChange}
              onPageSizeChange={this.handleOnPageSizeChange}
              onViewDetail={this.handleOnViewDetail}
            />
          </>
        )}
      </>
    );
  }
}

DeviceInfoTab.propTypes = {
  history: PropTypes.object,
  userId: PropTypes.string,
  deviceInfo: PropTypes.object,
  items: PropTypes.array,
  item: PropTypes.object,
  loading: PropTypes.bool,
  error: PropTypes.string,
  message: PropTypes.object,
  itemCount: PropTypes.number,
  pageCount: PropTypes.number,
  getDeviceInfo: PropTypes.func,
};

const mapStateToProps = ({ deviceInfo }) => {
  return { deviceInfo };
};

export default withRouter(
  connect(mapStateToProps, {
    getDeviceInfo,
  })(DeviceInfoTab)
);
